import type { LucideIcon } from "lucide-react";
import { Calculator, Send, Search, Banknote } from "lucide-react";

export type ProcessStep = {
  icon: LucideIcon;
  title: string;
  description: string;
};

export const processSteps: ProcessStep[] = [
  {
    icon: Calculator,
    title: "Calcule",
    description:
      "Use nossa calculadora para verificar se os juros do seu contrato estao acima da media de mercado.",
  },
  {
    icon: Send,
    title: "Envie seus dados",
    description:
      "Preencha o formulario com suas informacoes para que nossa equipe possa entrar em contato.",
  },
  {
    icon: Search,
    title: "Analise especializada",
    description:
      "Nossos advogados analisam detalhadamente seu contrato e identificam todas as cobranças indevidas.",
  },
  {
    icon: Banknote,
    title: "Recupere seu dinheiro",
    description:
      "Entramos com a acao judicial para revisar seu contrato e recuperar os valores pagos a mais.",
  },
];
